import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-divider',
  template: '<div class="divider"></div>',
  styleUrls: ['./divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DividerComponent {}
